module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper",
    staticStyle: {
      "min-height": "870px"
    }
  }, [_c('vue-headful', {
    attrs: {
      "title": 'SGP - ' + (_vm._.isUndefined(_vm.chamado.id) ? 'Abrindo chamado' : 'Chamado de n° ' + _vm.chamado.id)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fade-transition"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_vm._v("Chamados")]), _vm._v(" "), _c('b-breadcrumb', {
    attrs: {
      "items": [{
        text: 'Inicial',
        href: '/'
      }, {
        text: 'Cadastro',
        href: '#'
      }, {
        text: 'Chamados',
        active: true
      }]
    }
  })], 1), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row",
    attrs: {
      "id": "row1"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {}, [_c('div', {
    staticClass: "box box-primary"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "text-left box-header"
  }, [(_vm.esconderDados === false) ? _c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.esconderDados = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-caret-down",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Mostrar detalhes do Chamado - "), (_vm.chamado.id) ? _c('span', {
    staticStyle: {
      "color": "steelblue",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.chamado.id) + " (" + _vm._s(_vm.chamado.status.status) + ")")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.esconderDados === true) ? _c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.esconderDados = false
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-caret-up",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Ocultar detalhes do Chamado")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading.show),
      expression: "loading.show"
    }],
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "block"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]), _vm._v(" "), (_vm.esconderDados === true) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "name": "frmCommonRegister",
      "novalidate": ""
    }
  }, [_c('div', {
    staticClass: "col-md-7",
    attrs: {
      "id": "column1"
    }
  }, [_c('div', {
    staticClass: "form-group required-field"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "id"
    }
  }, [_vm._v("N° Chamado:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.chamado.id),
      expression: "chamado.id"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "numerochamado",
      "disabled": true,
      "type": "text",
      "minlength": "1",
      "ng-maxlength": "255"
    },
    domProps: {
      "value": (_vm.chamado.id)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.chamado, "id", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.diasEmAberto >= 0 && _vm.usuarioLogado.userType === 'FUNDACAO' && _vm.chamado.status.id !== 5) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "position": "relative",
      "top": "5px",
      "color": "#0f7b9f"
    }
  }, [_vm._v(" Aberto há: "), _c('b', [_vm._v(_vm._s(_vm.diasEmAberto))]), _vm._v(" "), (_vm.diasEmAberto > 1) ? _c('span', [_vm._v("dias")]) : _c('span', [_vm._v("dia")]), _vm._v(", "), _c('b', [_vm._v(_vm._s(_vm.horasEmAberto))]), _vm._v("h "), _c('b', [_vm._v(_vm._s(_vm.minutosEmAberto))]), _vm._v(" min\n                  ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "parametro"
    }
  }, [_vm._v("Descrição:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.chamado.descricao),
      expression: "chamado.descricao"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    staticStyle: {
      "height": "200px",
      "resize": "none",
      "border": "1px solid #a8a3a5"
    },
    attrs: {
      "name": "descricao",
      "disabled": true
    },
    domProps: {
      "value": (_vm.chamado.descricao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.chamado, "descricao", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field"
  }, [(_vm.chamado.projeto || _vm.chamado.processo_id) ? _c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "projeto"
    }
  }, [_vm._v("Projeto / ID:")]) : _vm._e(), _vm._v(" "), (_vm.chamado.projeto || _vm.chamado.processo_id) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.chamado.projeto),
      expression: "chamado.projeto"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "usuarioNome",
      "disabled": true
    },
    domProps: {
      "value": (_vm.chamado.projeto)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.chamado, "projeto", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.chamado.projeto || _vm.chamado.processo_id) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.chamado.processo_id),
      expression: "chamado.processo_id"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "processo",
      "disabled": true
    },
    domProps: {
      "value": (_vm.chamado.processo_id)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.chamado, "processo_id", $event.target.value)
      }
    }
  })])]) : _vm._e()]), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO' && (_vm.chamado.projeto || _vm.chamado.processo_id)) ? _c('div', {
    staticClass: "form-group required-field"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "carteira"
    }
  }, [_vm._v("Carteira:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.carteira),
      expression: "carteira"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "usuarioNome",
      "disabled": true
    },
    domProps: {
      "value": (_vm.carteira)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.carteira = $event.target.value
      }
    }
  })])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "parametro"
    }
  }, [_vm._v("Aberto por:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.usuarioNome),
      expression: "usuarioNome"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "usuarioNome",
      "disabled": true
    },
    domProps: {
      "value": (_vm.usuarioNome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.usuarioNome = $event.target.value
      }
    }
  })])]), _vm._v(" "), (_vm.chamado.usuario_abertura && !_vm._.isNull(_vm.chamado.usuario_abertura.fk_entidade)) ? _c('label', {
    staticClass: "col-md-3",
    staticStyle: {
      "position": "relative",
      "top": "5px"
    },
    attrs: {
      "for": "parametro"
    }
  }, [_vm._v("Representante Legal?")]) : _vm._e(), _vm._v(" "), (_vm.chamado.usuario_abertura && !_vm._.isNull(_vm.chamado.usuario_abertura.fk_entidade)) ? _c('div', {
    staticStyle: {
      "position": "relative",
      "top": "6px",
      "right": "70px",
      "color": "#0f7b9f"
    }
  }, [(_vm.chamado.dirigente && _vm.chamado.dirigente.bt_representante_legal === 1) ? _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
    }],
    staticStyle: {
      "color": "#0a568c"
    },
    attrs: {
      "title": '<h5><span style=\'color: #7adddd\'>Início Mandato: </span>' + _vm.formata(_vm.chamado.dirigente.dt_inicio_mandato) + '</h5>' +
        '<h5><span style=\'color: #7adddd\'>&nbsp&nbsp&nbspFim Mandato: </span>' + _vm.formata(_vm.chamado.dirigente.dt_fim_mandato) + '</h5>'
    }
  }, [_c('b', [_vm._v("Sim")])]) : _vm._e(), _vm._v(" "), (_vm.chamado.dirigente && _vm.chamado.dirigente.bt_representante_legal === 0) ? _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
    }],
    staticStyle: {
      "color": "#0a568c"
    },
    attrs: {
      "title": '<h5><span style=\'color: #7adddd\'>Início Mandato: </span>' + _vm.formata(_vm.chamado.dirigente.dt_inicio_mandato) + '</h5>' +
        '<h5><span style=\'color: #7adddd\'>&nbsp&nbsp&nbspFim Mandato: </span>' + _vm.formata(_vm.chamado.dirigente.dt_fim_mandato) + '</h5>'
    }
  }, [_c('b', [_vm._v("Não")])]) : _vm._e()]) : _vm._e()]), _vm._v(" "), (_vm.chamado.entidade) ? _c('div', {
    staticClass: "form-group required-field"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "parametro"
    }
  }, [_vm._v("Entidade:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.chamado.entidade.ds_nome),
      expression: "chamado.entidade.ds_nome"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "entidade",
      "disabled": true
    },
    domProps: {
      "value": (_vm.chamado.entidade.ds_nome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.chamado.entidade, "ds_nome", $event.target.value)
      }
    }
  })])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('dataInicial')
    }
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "data_inclusao"
    }
  }, [_vm._v("Data abertura: ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.chamado.data_inclusao),
      expression: "chamado.data_inclusao"
    }],
    ref: "dtInicial",
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "dataInicial",
      "data-vv-as": "Data Inclusão",
      "disabled": true
    },
    domProps: {
      "value": (_vm.chamado.data_inclusao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.chamado, "data_inclusao", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('dataInicial')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('dataInicial')))]) : _vm._e()])]), _vm._v(" "), (_vm.chamado.usuario_atendimento) ? _c('div', {
    staticClass: "form-group required-field"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "parametro"
    }
  }, [_vm._v("Em atendimento por:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.chamado.usuario_atendimento.ds_nome_usuario),
      expression: "chamado.usuario_atendimento.ds_nome_usuario"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "usuarioNome",
      "disabled": true
    },
    domProps: {
      "value": (_vm.chamado.usuario_atendimento.ds_nome_usuario)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.chamado.usuario_atendimento, "ds_nome_usuario", $event.target.value)
      }
    }
  })])])]) : _vm._e(), _vm._v(" "), (_vm.chamado.data_atendimento) ? _c('div', {
    staticClass: "form-group required-field"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "data_atendimento"
    }
  }, [_vm._v("Inicio atendimento: ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.chamado.data_atendimento),
      expression: "chamado.data_atendimento"
    }],
    ref: "dtInicial",
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "dataInicial",
      "data-vv-as": "Data Atendimento",
      "disabled": true
    },
    domProps: {
      "value": (_vm.chamado.data_atendimento)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.chamado, "data_atendimento", $event.target.value)
      }
    }
  })])])]) : _vm._e(), _vm._v(" "), (_vm.chamado.data_encerramento) ? _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('dataFinal')
    }
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "data_encerramento"
    }
  }, [_vm._v("Data Encerramento:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.chamado.data_encerramento),
      expression: "chamado.data_encerramento"
    }],
    ref: "Data Final",
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "dataFinal",
      "data-vv-as": "Data Final",
      "disabled": true
    },
    domProps: {
      "value": (_vm.chamado.data_encerramento)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.chamado, "data_encerramento", $event.target.value)
      }
    }
  })])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "parametro"
    }
  }, [_vm._v("Assunto:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('multiselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "options": _vm.assuntos,
      "multiple": false,
      "close-on-select": true,
      "clear-on-select": false,
      "hide-selected": false,
      "preserve-search": true,
      "placeholder": "Selecione um assunto",
      "custom-label": _vm.etiquetaAssunto,
      "preselect-first": false,
      "selectLabel": "",
      "label": "assunto",
      "track-by": "id",
      "deselectLabel": "",
      "selectedLabel": "Selecionado",
      "name": "assunto",
      "data-vv-as": "assunto",
      "disabled": _vm.habilita === false
    },
    on: {
      "select": function($event) {
        return _vm.changeAssunto($event)
      }
    },
    model: {
      value: (_vm.chamado.assunto),
      callback: function($$v) {
        _vm.$set(_vm.chamado, "assunto", $$v)
      },
      expression: "chamado.assunto"
    }
  }, [_c('span', {
    attrs: {
      "slot": "noOptions"
    },
    slot: "noOptions"
  }, [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("Nenhum registro localizado!")])], 1)])], 1), _vm._v(" "), (_vm.habilita === true) ? _c('span', {
    staticClass: "arrow blueArrow margemAssunto"
  }) : _vm._e()])]), _vm._v(" "), (_vm.chamado.assunto.area_responsavel) ? _c('div', {
    staticClass: "form-group required-field"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "parametro"
    }
  }, [_vm._v("Área Responsável:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.chamado.assunto.area_responsavel),
      expression: "chamado.assunto.area_responsavel"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "assunto",
      "disabled": true
    },
    domProps: {
      "value": (_vm.chamado.assunto.area_responsavel)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.chamado.assunto, "area_responsavel", $event.target.value)
      }
    }
  })])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "status"
    }
  }, [_vm._v("Status:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('div', {
    staticClass: "input-group"
  }, [(_vm.chamado.status.status === 'Aguardando Atendimento') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.chamado.status.status),
      expression: "chamado.status.status"
    }],
    staticClass: "form-control bordaAguardandoAtendimento",
    attrs: {
      "name": "status",
      "disabled": true
    },
    domProps: {
      "value": (_vm.chamado.status.status)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.chamado.status, "status", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.chamado.status.status === 'Em Atendimento') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.chamado.status.status),
      expression: "chamado.status.status"
    }],
    staticClass: "form-control bordaEmAtendimento",
    attrs: {
      "name": "status",
      "disabled": true
    },
    domProps: {
      "value": (_vm.chamado.status.status)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.chamado.status, "status", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.chamado.status.status === 'Aguardando Avaliação') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.chamado.status.status),
      expression: "chamado.status.status"
    }],
    staticClass: "form-control bordaAguardandoAvaliacao",
    attrs: {
      "name": "status",
      "disabled": true
    },
    domProps: {
      "value": (_vm.chamado.status.status)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.chamado.status, "status", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.chamado.status.status === 'Chamado Avaliado') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.chamado.status.status),
      expression: "chamado.status.status"
    }],
    staticClass: "form-control bordaChamadoAvaliado",
    attrs: {
      "name": "status",
      "disabled": true
    },
    domProps: {
      "value": (_vm.chamado.status.status)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.chamado.status, "status", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.chamado.status.status === 'Chamado Encerrado') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.chamado.status.status),
      expression: "chamado.status.status"
    }],
    staticClass: "form-control bordaChamadoEncerrado",
    attrs: {
      "name": "status",
      "disabled": true
    },
    domProps: {
      "value": (_vm.chamado.status.status)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.chamado.status, "status", $event.target.value)
      }
    }
  }) : _vm._e()])])]), _vm._v(" "), (_vm.chamado.documento) ? _c('div', {
    staticClass: "form-group required-field"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "status"
    }
  }, [_vm._v("Anexo:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        return _vm.onDownload(_vm.chamado.documento)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-download",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.chamado.documento.ds_nome_arquivo))])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "column2"
    }
  }, [(_vm.chamado.status.id !== 5) ? _c('fieldset', [_c('legend', [_vm._v("\n                      Opções do chamado:\n                    ")]), _vm._v(" "), (_vm.chamado.status.id === 1 && _vm.usuarioLogado.userType === 'FUNDACAO') ? _c('div', {
    staticClass: "col-md-7"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('button', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: "scale",
        distance: "1",
        size: "large",
        interactive: true,
        theme: "dark",
        placement: "right"
      }),
      expression: "{ inertia : true, arrow : true,  animation : \"scale\", distance:\"1\", size: \"large\", interactive: true, theme: \"dark\",  placement : \"right\"}"
    }],
    staticClass: "btn btn-flat relevo",
    staticStyle: {
      "margin-top": "10px",
      "color": "#048019"
    },
    attrs: {
      "uib-tooltip": "Inclui um evento",
      "type": "button",
      "title": '<h5>' + '<span style=\'color: #7adddd\'>' + 'O atendimento do chamado será iniciado.' + '</span>' + '</h5>'
    },
    on: {
      "click": function($event) {
        return _vm.iniciarAtendimento()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-hourglass-1",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("   Iniciar Atendimento")])])]) : _vm._e(), _vm._v(" "), (_vm.chamado.status.id == 2 && _vm.usuarioLogado.userType === 'FUNDACAO') ? _c('div', {
    staticClass: "col-md-7"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('button', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: "scale",
        distance: "1",
        size: "large",
        interactive: true,
        theme: "dark",
        placement: "right"
      }),
      expression: "{ inertia : true, arrow : true,  animation : \"scale\", distance:\"1\", size: \"large\", interactive: true, theme: \"dark\",  placement : \"right\"}"
    }],
    staticClass: "btn btn-flat",
    staticStyle: {
      "margin-top": "10px",
      "color": "#048019"
    },
    attrs: {
      "uib-tooltip": "Inclui um evento",
      "type": "button",
      "title": '<h5>' + '<span style=\'color: #7adddd\'>' + 'O chamado será devolvido para o status Aguardando Atendimento.' + '</span>' + '</h5>'
    },
    on: {
      "click": function($event) {
        return _vm.devolveAguardandoAtendimento()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-backward",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("   Devolver para Aguardando Atendimento")])])]) : _vm._e(), _vm._v(" "), (_vm.chamado.status.id !== 3 && _vm.chamado.status.id !== 4 && _vm.chamado.status.id !== 5 && _vm.habilitaSalvarReclassificacao === false && _vm.usuarioLogado.userType === 'FUNDACAO') ? _c('div', {
    staticClass: "col-md-7"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('button', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: "scale",
        distance: "1",
        size: "large",
        interactive: true,
        theme: "dark",
        placement: "right"
      }),
      expression: "{ inertia : true, arrow : true,  animation : \"scale\", distance:\"1\", size: \"large\", interactive: true, theme: \"dark\",  placement : \"right\"}"
    }],
    staticClass: "btn btn-flat",
    staticStyle: {
      "margin-top": "10px",
      "color": "#af8760"
    },
    attrs: {
      "uib-tooltip": "Inclui um evento",
      "type": "button",
      "title": '<h5>' + '<span style=\'color: #7adddd\'>' + 'Haverá a reclassificação do assunto do chamado.' + '</span>' + '</h5>'
    },
    on: {
      "click": function($event) {
        return _vm.reclassificarAssunto()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  Reclassificar Assunto")])])]) : _vm._e(), _vm._v(" "), (_vm.chamado.status.id !== 1 && _vm.chamado.status.id !== 4 && _vm.chamado.status.id !== 5 && _vm.usuarioLogado.userType === 'FUNDACAO' && _vm.botaoSalvaAnalista === false) ? _c('div', {
    staticClass: "col-md-7"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('button', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: "scale",
        distance: "1",
        size: "large",
        interactive: true,
        theme: "dark",
        placement: "right"
      }),
      expression: "{ inertia : true, arrow : true,  animation : \"scale\", distance:\"1\", size: \"large\", interactive: true, theme: \"dark\",  placement : \"right\"}"
    }],
    staticClass: "btn btn-flat",
    staticStyle: {
      "margin-top": "10px",
      "color": "#020202"
    },
    attrs: {
      "uib-tooltip": "Inclui um evento",
      "type": "button",
      "title": '<h5>' + '<span style=\'color: #7adddd\'>' + 'Ocorrerá a mudança do analista responsável pelo atendimento do chamado.' + '</span>' + '</h5>'
    },
    on: {
      "click": function($event) {
        return _vm.mostraAlterarAnalista()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-users",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  Alterar Analista")])])]) : _vm._e(), _vm._v(" "), (_vm.chamado.status.id !== 1 && _vm.chamado.status.id !== 4 && _vm.chamado.status.id !== 5 && _vm.usuarioLogado.userType === 'FUNDACAO') ? _c('div', {
    staticClass: "col-md-7"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('button', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: "scale",
        distance: "1",
        size: "large",
        interactive: true,
        theme: "dark",
        placement: "right"
      }),
      expression: "{ inertia : true, arrow : true,  animation : \"scale\", distance:\"1\", size: \"large\", interactive: true, theme: \"dark\",  placement : \"right\"}"
    }],
    staticClass: "btn btn-flat",
    staticStyle: {
      "margin-top": "10px",
      "color": "#000099"
    },
    attrs: {
      "uib-tooltip": "Inclui um evento",
      "type": "button",
      "title": '<h5>' + '<span style=\'color: #7adddd\'>' + 'Será aberto novo suporte referente ao chamado.' + '</span>' + '</h5>'
    },
    on: {
      "click": function($event) {
        return _vm.mostraTextoNovoSuporte()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-bug",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  Criar Suporte FBB")])])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.chamado.status.id !== 4 && _vm.chamado.status.id !== 5 && _vm.usuarioLogado.userType === 'FUNDACAO' && _vm.mostraTextoSuporte === true) ? _c('div', {
    staticClass: "col-md-7"
  }, [_c('div', [_c('label', {
    staticClass: "col-md-7",
    attrs: {
      "for": "parametro"
    }
  }, [_vm._v("Selecione o problema:")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.problemas,
      "label": "problema",
      "track-by": "prob_id",
      "multiple": false,
      "close-on-select": true,
      "clear-on-select": false,
      "placeholder": "Selecione um problema"
    },
    on: {
      "select": function($event) {
        return _vm.onSelecionaProblema($event)
      }
    },
    model: {
      value: (this.problemaSelecionado),
      callback: function($$v) {
        _vm.$set(this, "problemaSelecionado", $$v)
      },
      expression: "this.problemaSelecionado"
    }
  }, [_c('span', {
    attrs: {
      "slot": "noOptions"
    },
    slot: "noOptions"
  }, [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("Nenhum registro localizado!")])], 1)])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.chamado.status.id !== 4 && _vm.chamado.status.id !== 5 && _vm.usuarioLogado.userType === 'FUNDACAO' && _vm.mostraTextoSuporte === true) ? _c('div', {
    staticClass: "col-md-7"
  }, [_c('div', [_c('br'), _vm._v(" "), _c('label', {
    staticClass: "col-md-7",
    attrs: {
      "for": "parametro"
    }
  }, [_vm._v("Descrição do problema:")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.descricaoSuporte),
      expression: "descricaoSuporte"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    staticStyle: {
      "height": "200px",
      "resize": "both",
      "border": "1px solid #a8a3a5"
    },
    attrs: {
      "name": "resolucao"
    },
    domProps: {
      "value": (_vm.descricaoSuporte)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.descricaoSuporte = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mt-2 d-flex gap-2",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.onOkDescricao
    }
  }, [_vm._v("\n                            OK\n                          ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-secondary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.onCancelarDescricao
    }
  }, [_vm._v("\n                            Cancelar\n                          ")])])])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.chamado.status.id !== 4 && _vm.chamado.status.id !== 5 && _vm.usuarioLogado.userType === 'FUNDACAO' && _vm.botaoSalvaAnalista === true) ? _c('div', {
    staticClass: "col-md-7"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('button', {
    staticClass: "btn btn-flat",
    staticStyle: {
      "margin-top": "10px",
      "color": "#020202"
    },
    attrs: {
      "uib-tooltip": "Inclui um evento",
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.salvaNovoAnalista()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-users",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  Salva Troca Analista")])]), _vm._v(" "), _c('span', {
    staticClass: "arrow redArrow margemTrocaAnalista"
  })]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.chamado.status.id === 3 && _vm.usuarioLogado.userType === 'FUNDACAO') ? _c('div', {
    staticClass: "col-md-7"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('button', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: "scale",
        distance: "1",
        size: "large",
        interactive: true,
        theme: "dark",
        placement: "right"
      }),
      expression: "{ inertia : true, arrow : true,  animation : \"scale\", distance:\"1\", size: \"large\", interactive: true, theme: \"dark\",  placement : \"right\"}"
    }],
    staticClass: "btn  btn-flat",
    staticStyle: {
      "margin-top": "10px",
      "color": "#f40022"
    },
    attrs: {
      "uib-tooltip": "Inclui um evento",
      "type": "button",
      "title": '<h5>' + '<span style=\'color: #7adddd\'>' + 'O chamado será encerrado mesmo sem a avaliação do usuário e estará disponível somente para consulta.' + '</span>' + '</h5>'
    },
    on: {
      "click": function($event) {
        return _vm.encerrarAtendimentoSemAvaliacao()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check-square-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("   Encerrar Atendimento Sem Avaliação")]), _vm._v(" "), _c('span', {
    staticClass: "arrow blueArrow margemEncerraSemAvaliacao"
  })])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.chamado.status.id !== 4 && _vm.chamado.status.id !== 5 && _vm.usuarioLogado.userType === 'FUNDACAO' && _vm.mostraListaUsuarios === true) ? _c('div', {
    staticClass: "col-md-7"
  }, [_c('div', [_c('label', {
    staticClass: "col-md-7",
    attrs: {
      "for": "parametro"
    }
  }, [_vm._v("Selecione um usuário:")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('multiselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "options": _vm.usuarios,
      "multiple": false,
      "close-on-select": true,
      "clear-on-select": false,
      "hide-selected": false,
      "preserve-search": true,
      "placeholder": "Selecione um assunto",
      "custom-label": _vm.etiquetaUsuario,
      "preselect-first": false,
      "selectLabel": "",
      "label": "usuarioAlterado",
      "track-by": "id",
      "deselectLabel": "",
      "selectedLabel": "Selecionado",
      "name": "usuarioAlterado",
      "data-vv-as": "usuarioAlterado"
    },
    on: {
      "select": function($event) {
        return _vm.changeUsuario($event)
      }
    },
    model: {
      value: (_vm.usuarioAlterado),
      callback: function($$v) {
        _vm.usuarioAlterado = $$v
      },
      expression: "usuarioAlterado"
    }
  }, [_c('span', {
    attrs: {
      "slot": "noOptions"
    },
    slot: "noOptions"
  }, [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("Nenhum registro localizado!")])], 1)])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.chamado.status.id !== 3 && _vm.chamado.status.id !== 4 && _vm.chamado.status.id !== 5 && _vm.habilitaSalvarReclassificacao === true && _vm.usuarioLogado.userType === 'FUNDACAO') ? _c('div', {
    staticClass: "col-md-7"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('button', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: "scale",
        distance: "1",
        size: "large",
        interactive: true,
        theme: "dark",
        placement: "right"
      }),
      expression: "{ inertia : true, arrow : true,  animation : \"scale\", distance:\"1\", size: \"large\", interactive: true, theme: \"dark\",  placement : \"right\"}"
    }],
    staticClass: "btn btn-flat",
    staticStyle: {
      "margin-top": "10px",
      "color": "#af8760"
    },
    attrs: {
      "type": "button",
      "title": '<h5>' + '<span style=\'color: #7adddd\'>' + 'Confirma a reclassificação do chamado' + '</span>' + '</h5>'
    },
    on: {
      "click": function($event) {
        return _vm.salvaReclassificacao()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-floppy-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  Salvar Reclassificação")])]), _vm._v(" "), _c('span', {
    staticClass: "arrow redArrow margemTrocaAnalista"
  }), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.chamado.status.id === 4 && _vm.usuarioLogado.userType === 'FUNDACAO') ? _c('div', {
    staticClass: "col-md-7"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('button', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: "scale",
        distance: "1",
        size: "large",
        interactive: true,
        theme: "dark",
        placement: "right"
      }),
      expression: "{ inertia : true, arrow : true,  animation : \"scale\", distance:\"1\", size: \"large\", interactive: true, theme: \"dark\",  placement : \"right\"}"
    }],
    staticClass: "btn  btn-flat",
    staticStyle: {
      "margin-top": "10px",
      "color": "#f40022"
    },
    attrs: {
      "uib-tooltip": "Inclui um evento",
      "type": "button",
      "title": '<h5>' + '<span style=\'color: #7adddd\'>' + 'O chamado será encerrado e estará disponível somente para consulta.' + '</span>' + '</h5>'
    },
    on: {
      "click": function($event) {
        return _vm.encerrarAtendimento()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check-square-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("   Encerrar Atendimento")]), _vm._v(" "), _c('span', {
    staticClass: "arrow blueArrow margemTrocaAnalista"
  })])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.chamado.status.id === 3 && _vm.usuarioLogado.userType === 'ENTIDADE') ? _c('div', {
    staticClass: "col-md-7"
  }, [_c('legend', [_vm._v("\n                        O seu problema foi solucionado?\n                      ")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "box-body",
    staticStyle: {
      "padding-top": "0px"
    }
  }, [_c('div', {
    staticClass: "col-md-2 form-group required",
    class: {
      'has-error': _vm.errors.first('problemaSN')
    }
  }, [_c('label', {
    staticClass: "new-control new-control-radio",
    staticStyle: {
      "padding-top": "8px"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.problemaResolvido),
      expression: "problemaResolvido"
    }],
    attrs: {
      "type": "radio",
      "name": "problemaSN",
      "value": "SIM"
    },
    domProps: {
      "checked": _vm._q(_vm.problemaResolvido, "SIM")
    },
    on: {
      "change": function($event) {
        _vm.problemaResolvido = "SIM"
      }
    }
  }), _vm._v(" Sim\n                              "), _c('div', {
    staticClass: "new-control-indicator"
  })]), _vm._v(" "), _c('label', {
    staticClass: "new-control new-control-radio",
    staticStyle: {
      "padding-top": "8px"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.problemaResolvido),
      expression: "problemaResolvido"
    }],
    attrs: {
      "type": "radio",
      "name": "problemaSN",
      "value": "NAO"
    },
    domProps: {
      "checked": _vm._q(_vm.problemaResolvido, "NAO")
    },
    on: {
      "change": function($event) {
        _vm.problemaResolvido = "NAO"
      }
    }
  }), _vm._v(" Não\n                              "), _c('div', {
    staticClass: "new-control-indicator"
  })]), _vm._v(" "), (_vm.errors.first('problemaSN')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(('O campo acima deve ser marcado com Sim ou Não')))]) : _vm._e()])])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.chamado.status.id === 3 && _vm.rating === 0 && _vm.problemaResolvido === 'NAO') ? _c('div', {
    staticClass: "col-md-7 form-group required-field"
  }, [_c('b', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("Informe o que faltou para a resolução:")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.resolucaoNOK),
      expression: "resolucaoNOK"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    staticStyle: {
      "height": "200px",
      "resize": "both",
      "border": "1px solid #a8a3a5"
    },
    attrs: {
      "name": "resolucao",
      "placeholder": _vm.place
    },
    domProps: {
      "value": (_vm.resolucaoNOK)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.resolucaoNOK = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.errors.first('resolucaoNOK')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('resolucaoNOK')))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.chamado.status.id === 3 && _vm.rating === 0 && _vm.problemaResolvido === 'NAO' && _vm.resolucaoNOK.length > 0) ? _c('div', {
    staticClass: "col-md-7"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('button', {
    staticClass: "btn  btn-flat",
    staticStyle: {
      "margin-top": "10px",
      "color": "#001eff"
    },
    attrs: {
      "uib-tooltip": "Inclui um evento",
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.devolverChamado()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-backward",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("   Devolver Chamado")])]), _vm._v(" "), (_vm.problemaResolvido === 'NAO' && _vm.chamado.status.id !== 4 && _vm.chamado.status.id !== 5) ? _c('span', {
    staticClass: "arrow redArrow margemTrocaAnalista"
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.chamado.status.id === 3 && _vm.rating === 0 && _vm.problemaResolvido === 'SIM') ? _c('div', {
    staticClass: "col-md-7"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('button', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: "scale",
        distance: "1",
        size: "large",
        interactive: true,
        theme: "dark",
        placement: "right"
      }),
      expression: "{ inertia : true, arrow : true,  animation : \"scale\", distance:\"1\", size: \"large\", interactive: true, theme: \"dark\",  placement : \"right\"}"
    }],
    staticClass: "btn  btn-flat",
    staticStyle: {
      "margin-top": "10px",
      "color": "#001eff"
    },
    attrs: {
      "uib-tooltip": "Inclui um evento",
      "type": "button",
      "title": '<h5>' + '<span style=\'color: #7adddd\'>' + 'Após a FBB informar que o chamado foi solucionado, clique aqui para efetuar a avaliação.' + '</span>' + '</h5>'
    },
    on: {
      "click": function($event) {
        return _vm.avaliarChamado()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-star-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("   Avaliar Chamado")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [(_vm.chamado.status.id === 3 && _vm.rating > 0 && _vm.mostraAvaliacao === true && _vm.problemaResolvido === 'SIM') ? _c('button', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: "scale",
        distance: "1",
        size: "large",
        interactive: true,
        theme: "dark",
        placement: "right"
      }),
      expression: "{ inertia : true, arrow : true,  animation : \"scale\", distance:\"1\", size: \"large\", interactive: true, theme: \"dark\",  placement : \"right\"}"
    }],
    staticClass: "btn  btn-flat",
    staticStyle: {
      "margin-top": "10px",
      "color": "#001eff"
    },
    attrs: {
      "uib-tooltip": "Inclui um evento",
      "type": "button",
      "title": '<h5>' + '<span style=\'color: #7adddd\'>' + 'Após efetuar a avaliação, seu chamado será encaminhado para encerramento da FBB.' + '</span>' + '</h5>'
    },
    on: {
      "click": function($event) {
        return _vm.enviarAvaliacaoEEncerrar()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-floppy-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("   Avaliar e enviar para encerramento")]) : _vm._e(), _vm._v(" "), (_vm.problemaResolvido === 'SIM' && _vm.chamado.status.id !== 4 && _vm.chamado.status.id !== 5) ? _c('span', {
    staticClass: "arrow redArrow margemEncerramento"
  }) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.chamado.status.id === 3 && _vm.mostraAvaliacao === true && _vm.problemaResolvido === 'SIM') ? _c('div', [_vm._m(1), _vm._v(" "), _vm._m(2)]) : _vm._e(), _vm._v(" "), (_vm.chamado.status.id === 3 && _vm.mostraAvaliacao === true && _vm.problemaResolvido === 'SIM') ? _c('star-rating', {
    attrs: {
      "text-class": "custom-text",
      "active-color": ['red', '#ff6600', '#eead2d', '#74B72E', 'green'],
      "animate": "true"
    },
    on: {
      "update:rating": _vm.setRating
    },
    model: {
      value: (_vm.rating),
      callback: function($$v) {
        _vm.rating = $$v
      },
      expression: "rating"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (((_vm.chamado.status.id === 5 || _vm.chamado.status.id === 4) && (_vm.chamado.nota && _vm.chamado.nota.nota && !_vm._.isNull(_vm.chamado.nota.nota)))) ? _c('div', {
    staticClass: "col-md-7"
  }, [_c('span', {
    staticStyle: {
      "color": "#3d3d3d",
      "font-weight": "bolder"
    }
  }, [_vm._v("Chamado avaliado:")]), _vm._v(" "), _vm._m(3), _vm._v(" "), (_vm.chamado.status.id === 5 || _vm.chamado.status.id === 4) ? _c('star-rating', {
    staticClass: "custom-text",
    attrs: {
      "active-color": ['red', '#ff6600', '#eead2d', '#74B72E', 'green'],
      "read-only": true
    },
    model: {
      value: (_vm.chamado.nota.nota),
      callback: function($$v) {
        _vm.$set(_vm.chamado.nota, "nota", $$v)
      },
      expression: "chamado.nota.nota"
    }
  }) : _vm._e()], 1) : _vm._e()])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {}, [_c('div', {
    staticClass: "box box-primary"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [(_vm.table.totalRows > 0 && _vm.table.totalRows < 2) ? _c('span', [_vm._v(" O chamado possui "), _c('b', [_vm._v(" " + _vm._s(_vm.table.totalRows) + " ")]), _vm._v(" assentamento ")]) : (_vm.table.totalRows > 0) ? _c('span', [_vm._v(" O chamado possui "), _c('b', [_vm._v(" " + _vm._s(_vm.table.totalRows) + " ")]), _vm._v(" assentamentos ")]) : _vm._e()])]), _vm._v(" "), (_vm.chamado.status.id !== 5 && _vm.apertouSalvar === false) ? _c('button', {
    staticClass: "btn btn-primary btn-flat",
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "disabled": _vm.chamado.status.id == 1 && _vm.usuarioLogado.userType === 'FUNDACAO',
      "uib-tooltip": "Inclui um evento na tabela abaixo",
      "type": "button"
    },
    on: {
      "click": [function($event) {
        _vm.mostraNovo = true
      }, function($event) {
        $event.preventDefault();
        return _vm.irAte()
      }]
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Incluir Assentamento")]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-table', {
    ref: "table",
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "bordered": _vm.table.bordered,
      "items": _vm.table.items,
      "hover": _vm.table.hover,
      "fields": _vm.table.fields,
      "filter": _vm.table.filter,
      "current-page": _vm.table.currentPage,
      "per-page": _vm.table.perPage,
      "sort-by": _vm.table.sortBy,
      "sort-desc": _vm.table.sortDesc,
      "empty-text": "Nenhum registro encontrado"
    },
    on: {
      "filtered": _vm.onFiltered,
      "update:sortBy": function($event) {
        return _vm.$set(_vm.table, "sortBy", $event)
      },
      "update:sort-by": function($event) {
        return _vm.$set(_vm.table, "sortBy", $event)
      },
      "update:sortDesc": function($event) {
        return _vm.$set(_vm.table, "sortDesc", $event)
      },
      "update:sort-desc": function($event) {
        return _vm.$set(_vm.table, "sortDesc", $event)
      }
    },
    scopedSlots: _vm._u([{
      key: "data_inclusao",
      fn: function(row) {
        return [_vm._v(_vm._s(_vm._f("moment")(row.value, 'DD/MM/YYYY HH:mm:ss')))]
      }
    }, {
      key: "descricao",
      fn: function(row) {
        return [_c('span', {
          domProps: {
            "innerHTML": _vm._s(row.value)
          }
        })]
      }
    }, {
      key: "usuario.ds_nome_usuario",
      fn: function(row) {
        return [(row.item.usuario && row.item.usuario.ds_tipo_usuario === 'ENTIDADE') ? _c('span', [_vm._v(" " + _vm._s(row.value) + " "), _c('br'), _vm._v(" "), (_vm.chamado.entidade) ? _c('span', {
          staticStyle: {
            "font-style": "italic",
            "color": "#0a568c"
          }
        }, [_vm._v("(" + _vm._s(_vm.chamado.entidade.ds_nome) + ")")]) : _vm._e()]) : (row.item.usuario && row.item.usuario.ds_tipo_usuario === 'FUNDACAO') ? _c('span', [_vm._v(" " + _vm._s(row.value) + " "), _c('br'), _vm._v(" "), _c('span', {
          staticStyle: {
            "font-style": "italic",
            "color": "#0a568c"
          }
        }, [_vm._v("(Fundação Banco do Brasil)")])]) : _vm._e()]
      }
    }, {
      key: "anexos",
      fn: function(row) {
        return [(row.value && row.value.length > 0) ? _c('div', _vm._l((row.value), function(documento) {
          return _c('div', {
            key: documento.id,
            staticClass: "documento-item"
          }, [_c('a', {
            attrs: {
              "href": "javascript:void(0)"
            },
            on: {
              "click": function($event) {
                return _vm.onDownload(documento)
              }
            }
          }, [(documento.ds_nome_arquivo) ? _c('span', [_c('i', {
            staticClass: "fa fa-download",
            attrs: {
              "aria-hidden": "true"
            }
          }), _vm._v(" " + _vm._s(documento.ds_nome_arquivo) + "\n                              ")]) : _c('span')])])
        }), 0) : _c('span', [_vm._v("\n                          Nenhum anexo\n                        ")])]
      }
    }])
  }, [_c('template', {
    slot: "empty"
  }, [(_vm.carregou === false) ? _c('div', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "block"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })])]) : _vm._e()])], 2), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "6",
      "right": ""
    }
  }, [_c('b-pagination', {
    staticClass: "my-3",
    attrs: {
      "total-rows": _vm.table.totalRows,
      "per-page": _vm.table.perPage
    },
    model: {
      value: (_vm.table.currentPage),
      callback: function($$v) {
        _vm.$set(_vm.table, "currentPage", $$v)
      },
      expression: "table.currentPage"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.mostraNovo === true) ? _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('assentamento')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-2",
    attrs: {
      "for": "parametro"
    }
  }, [_vm._v("Assentamento:")]), _vm._v(" "), (_vm.mostraNovo === true) ? _c('div', {
    ref: "assentamentoNovo",
    staticClass: "col-md-4"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.assentamento.descricao),
      expression: "assentamento.descricao"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    staticStyle: {
      "height": "200px",
      "resize": "none",
      "border": "1px solid #a8a3a5"
    },
    attrs: {
      "name": "assentamento",
      "placeholder": _vm.placeAssentamento
    },
    domProps: {
      "value": (_vm.assentamento.descricao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.assentamento, "descricao", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.first('assentamento')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('assentamento')))]) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO') ? _c('div', [_c('br'), _vm._v(" "), _c('label', [_vm._v("Deixar visível para a Entidade?")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.assentamento.visivel_entidade),
      expression: "assentamento.visivel_entidade"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "visivel_entidade"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.assentamento, "visivel_entidade", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Não")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Sim")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('upload-documentos-chamado', {
    attrs: {
      "propDocumentos": _vm.assentamento.anexos
    }
  })], 1) : _vm._e()]), _vm._v(" "), (_vm.mostraNovo === true) ? _c('button', {
    staticClass: "btn btn-success btn-flat",
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "uib-tooltip": "Inclui um evento na tabela abaixo",
      "type": "button"
    },
    on: {
      "click": _vm.adicionaAssentamento
    }
  }, [_c('i', {
    staticClass: "fa fa-floppy-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("   Salvar")]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.mostraNovo === true) ? _c('button', {
    staticClass: "btn btn-primary btn-flat",
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "uib-tooltip": "Inclui um evento na tabela abaixo",
      "type": "button"
    },
    on: {
      "click": _vm.fechaAssentamento
    }
  }, [_c('i', {
    staticClass: "fa fa-close",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("   Fechar")]) : _vm._e(), _vm._v(" "), (_vm.chamado.status.id === 2 && _vm.usuarioLogado.userType === 'FUNDACAO') ? _c('div', [_c('button', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: "scale",
        distance: "1",
        size: "large",
        interactive: true,
        theme: "dark",
        placement: "right"
      }),
      expression: "{ inertia : true, arrow : true,  animation : \"scale\", distance:\"1\", size: \"large\", interactive: true, theme: \"dark\",  placement : \"right\"}"
    }],
    staticClass: "btn  btn-flat",
    class: {
      'botao-desabilitado': !_vm.assentamento.descricao
    },
    staticStyle: {
      "margin-top": "10px",
      "color": "#001eff"
    },
    attrs: {
      "uib-tooltip": "Inclui um evento",
      "type": "button",
      "title": '<h5>' + '<span style=\'color: #7adddd\'>' + 'Após ter solucionado o problema, preencha o assentamento e envie o chamado para avaliação do usuário.' + '</span>' + '</h5>',
      "disabled": !_vm.assentamento.descricao
    },
    on: {
      "click": function($event) {
        return _vm.enviarAvaliacao()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-star-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("   Salvar e Enviar para Avaliação")])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('g-button-moema', {
    attrs: {
      "color": "warning",
      "size": "button--size-ss"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'cadastro-chamado-lista'
        })
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-circle-left",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Voltar ")])], 1)])])])])])]), _vm._v(" "), _c('vue-snotify')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-pencil",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Editando Chamado")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', [_vm._v("Sua opinião é muito importante! Avalie este atendimento.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "font-size": "x-small"
    }
  }, [_c('i', {
    staticClass: "fa fa-star",
    staticStyle: {
      "color": "red"
    }
  }), _vm._v(": Muito ruim | "), _c('i', {
    staticClass: "fa fa-star",
    staticStyle: {
      "color": "#ff6600"
    }
  }), _c('i', {
    staticClass: "fa fa-star",
    staticStyle: {
      "color": "#ff6600"
    }
  }), _vm._v(": Ruim | "), _c('i', {
    staticClass: "fa fa-star",
    staticStyle: {
      "color": "#eead2d"
    }
  }), _c('i', {
    staticClass: "fa fa-star",
    staticStyle: {
      "color": "#eead2d"
    }
  }), _c('i', {
    staticClass: "fa fa-star",
    staticStyle: {
      "color": "#eead2d"
    }
  }), _vm._v(": Regular | "), _c('i', {
    staticClass: "fa fa-star",
    staticStyle: {
      "color": "#74B72E"
    }
  }), _c('i', {
    staticClass: "fa fa-star",
    staticStyle: {
      "color": "#74B72E"
    }
  }), _c('i', {
    staticClass: "fa fa-star",
    staticStyle: {
      "color": "#74B72E"
    }
  }), _c('i', {
    staticClass: "fa fa-star",
    staticStyle: {
      "color": "#74B72E"
    }
  }), _vm._v(": Bom | "), _c('i', {
    staticClass: "fa fa-star",
    staticStyle: {
      "color": "green"
    }
  }), _c('i', {
    staticClass: "fa fa-star",
    staticStyle: {
      "color": "green"
    }
  }), _c('i', {
    staticClass: "fa fa-star",
    staticStyle: {
      "color": "green"
    }
  }), _c('i', {
    staticClass: "fa fa-star",
    staticStyle: {
      "color": "green"
    }
  }), _c('i', {
    staticClass: "fa fa-star",
    staticStyle: {
      "color": "green"
    }
  }), _vm._v(": Ótimo.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', {
    staticStyle: {
      "font-size": "x-small"
    }
  }, [_c('i', {
    staticClass: "fa fa-star",
    staticStyle: {
      "color": "red"
    }
  }), _vm._v(": Muito ruim | "), _c('i', {
    staticClass: "fa fa-star",
    staticStyle: {
      "color": "#ff6600"
    }
  }), _c('i', {
    staticClass: "fa fa-star",
    staticStyle: {
      "color": "#ff6600"
    }
  }), _vm._v(": Ruim | "), _c('i', {
    staticClass: "fa fa-star",
    staticStyle: {
      "color": "#eead2d"
    }
  }), _c('i', {
    staticClass: "fa fa-star",
    staticStyle: {
      "color": "#eead2d"
    }
  }), _c('i', {
    staticClass: "fa fa-star",
    staticStyle: {
      "color": "#eead2d"
    }
  }), _vm._v(": Regular | "), _c('i', {
    staticClass: "fa fa-star",
    staticStyle: {
      "color": "#74B72E"
    }
  }), _c('i', {
    staticClass: "fa fa-star",
    staticStyle: {
      "color": "#74B72E"
    }
  }), _c('i', {
    staticClass: "fa fa-star",
    staticStyle: {
      "color": "#74B72E"
    }
  }), _c('i', {
    staticClass: "fa fa-star",
    staticStyle: {
      "color": "#74B72E"
    }
  }), _vm._v(": Bom | "), _c('i', {
    staticClass: "fa fa-star",
    staticStyle: {
      "color": "green"
    }
  }), _c('i', {
    staticClass: "fa fa-star",
    staticStyle: {
      "color": "green"
    }
  }), _c('i', {
    staticClass: "fa fa-star",
    staticStyle: {
      "color": "green"
    }
  }), _c('i', {
    staticClass: "fa fa-star",
    staticStyle: {
      "color": "green"
    }
  }), _c('i', {
    staticClass: "fa fa-star",
    staticStyle: {
      "color": "green"
    }
  }), _vm._v(": Ótimo.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-list-alt",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Retorno para a Entidade")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Anexo")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-78c5ea08!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/cadastro/chamado/EditarChamado.vue
// module id = 2028
// module chunks = 1